import React, { forwardRef, useEffect, useState } from 'react';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import { Control } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { useCardsFilters } from '../useCardsFilters';

function CardIdFilterPopover(
  {
    ...props
  }: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useTranslation();
  const [localValue, setLocalValue] = useState<string>('');
  const { filters, updateFilters, updateFiltersDebounced } = useCardsFilters();

  const onChangeHandler = (cardIds: string) => {
    setLocalValue(cardIds);
    updateFiltersDebounced({ card_ids: cardIds?.length > 0 ? cardIds.split(',').map((cardId) => cardId.trim()) : undefined });
  };

  useEffect(() => {
    setLocalValue(filters?.card_ids?.join(',') ?? '');
  }, [filters]);

  const reset = () => {
    updateFilters({ card_ids: undefined });
  };

  return (
    <PopoverWithButton
      {...props}
      onClickReset={reset}
      ref={ref}
      title={<div className="Body-2">{t('lunapoint:картотека.external_id')}</div>}
    >
      <Control.Input
        isClearable
        onChangeValue={onChangeHandler}
        onClear={reset}
        value={localValue}
      />
    </PopoverWithButton>
  );
}

const CardIdFilterPopoverWithRef = forwardRef(CardIdFilterPopover);
export { CardIdFilterPopoverWithRef as CardIdFilterPopover };
